import { Link, useNavigate } from "react-router-dom";
import { Languages, Lock, LogOut, LayoutDashboard } from "lucide-react";
import { useLang } from "@/i18n";
import { useAuth } from "@/context/AuthContext";

export function SiteHeader({ right = null }) {
  const { lang, toggle, t } = useLang();
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isAuthed = user && typeof user === "object";

  const handleLogout = async () => {
    await logout();
    navigate("/", { replace: true });
  };

  return (
    <header className="w-full border-b border-border bg-white/85 backdrop-blur-md sticky top-0 z-40">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between gap-3">
        <nav className="flex items-center gap-4 sm:gap-5">
          <Link
            to="/"
            data-testid="nav-home"
            className="text-sm font-semibold text-ink hover:text-sage-dark transition-colors duration-200"
          >
            {t("nav.home")}
          </Link>
          <Link
            to="/archiv"
            data-testid="nav-archive"
            className="text-sm font-semibold text-gray-500 hover:text-ink transition-colors duration-200"
          >
            {t("nav.archive")}
          </Link>
        </nav>

        <div className="flex items-center gap-2 sm:gap-3">
          <button
            onClick={toggle}
            data-testid="lang-toggle"
            className="inline-flex items-center gap-1.5 h-9 px-2.5 sm:px-3 rounded-sm border border-border text-sm font-bold text-ink hover:border-ink hover:bg-secondary transition-colors duration-200"
            title="SK / EN"
          >
            <Languages className="h-4 w-4" strokeWidth={2} />
            {lang === "sk" ? "EN" : "SK"}
          </button>

          {right}

          {isAuthed ? (
            <>
              <Link
                to="/admin/dashboard"
                data-testid="nav-admin-dashboard"
                className="inline-flex items-center gap-1.5 h-9 px-2.5 sm:px-3 rounded-sm bg-ink text-white text-sm font-semibold hover:bg-sage-dark transition-colors duration-200"
              >
                <LayoutDashboard className="h-4 w-4" strokeWidth={2} />
                <span className="hidden sm:inline">{t("nav.adminPanel")}</span>
              </Link>
              <button
                onClick={handleLogout}
                data-testid="nav-logout"
                title={t("nav.logout")}
                className="inline-flex items-center gap-1.5 h-9 px-2.5 sm:px-3 rounded-sm border border-border text-sm font-semibold text-gray-500 hover:text-destructive hover:border-destructive transition-colors duration-200"
              >
                <LogOut className="h-4 w-4" strokeWidth={2} />
                <span className="hidden sm:inline">{t("nav.logout")}</span>
              </button>
            </>
          ) : user === false ? (
            <Link
              to="/admin/login"
              data-testid="nav-admin-login"
              className="inline-flex items-center gap-1.5 h-9 px-2.5 sm:px-3 rounded-sm border border-border text-sm font-semibold text-ink hover:border-ink hover:bg-secondary transition-colors duration-200"
            >
              <Lock className="h-4 w-4" strokeWidth={2} />
              <span className="hidden sm:inline">{t("nav.login")}</span>
            </Link>
          ) : null}
        </div>
      </div>
    </header>
  );
}
